import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';

import { getEvent } from '../restapi/warningEvent';


export function useEventId() {
	const {id} = useParams<{ id: string }>();
	return parseInt(id || '0');
}

export function useCurrentEvent() {
	const id = useEventId();
	const q = useQuery(['event', id], () => getEvent(id), {
		enabled: !!id,  // load only if there is a valid id
	});
	return q.data;
}
